"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeResultMessage = exports.serializeResultMessage = void 0;
var letter_message_1 = require("./letter_message");
var sentence_message_1 = require("./sentence_message");
function serializeResultMessage(subjectId, experimentVersion, timestamp, letterResult, sentenceResult) {
    return {
        subject_id: subjectId,
        experiment_version: experimentVersion,
        timestamp: timestamp.toISOString(),
        letter_result: (0, letter_message_1.serializeLetterResult)(letterResult),
        sentence_result: (0, sentence_message_1.serializeSentenceResult)(sentenceResult),
    };
}
exports.serializeResultMessage = serializeResultMessage;
function deserializeResultMessage(result) {
    return {
        subject_id: result.subject_id,
        experiment_version: result.experiment_version,
        timestamp: new Date(result.timestamp),
        letter_result: (0, letter_message_1.deserializeLetterResult)(result.letter_result),
        sentence_result: (0, sentence_message_1.deserializeSentenceResult)(result.sentence_result),
    };
}
exports.deserializeResultMessage = deserializeResultMessage;
